import {FC} from "react";
import {Link} from "../../../ui";
import {CityInform} from "../index";
import styled from "styled-components";
import useDrawer from "../../../hooks/useDrawer";
import Loading from "../../../ui/Loading/Loading";
import {LoadingIcon} from "../../../ui/Icons";
import {useAppSelector} from "../../../hooks/useAppDispatch";
import {useGetCityRootByIdQuery} from "./__generated__/CityRoot.query.generated";


const Options = styled.div`
  h2 {
    font-weight: 400;
    color: ${props => props.theme.palette.purple};
  }
  ul {
    display: flex;
    flex-direction: column;
  }
`;


const CityRoot:FC = () => {
  const { openChildrenHandler } = useDrawer();
  const { id } = useAppSelector(state => state.drawer);
  const { data, loading, error } = useGetCityRootByIdQuery({ variables: { id }});

  if (loading || !data) {
    return (
      <Loading><LoadingIcon /></Loading>
    );
  }

  if (error) {
    return <p>{error.message}</p>;
  }

  if (!data?.getCityById) {
    return <p>Возможно произошла ошибка или ID был пуст</p>;
  }

  return (
    <>
      <CityInform
        info={data.getCityById}
      />
      <Options>
        <h2>Управление городом</h2>
        <ul>
          <Link onClick={() => openChildrenHandler('citySettingsEdit')}>Редактировать город</Link>
          <Link onClick={() => openChildrenHandler('citySettingsDelete')}>Удалить город</Link>
        </ul>
      </Options>
    </>
  )
}

export default CityRoot;
